export default "__VITE_ASSET__DwbVZAUS__"